// Owner: doc-variants (owner feedback F12). ⌘K: the clause library. Discovered by glob; keep this file tiny.
import { defineAppCommands } from '../../extensions/commands';
import { t } from '../../lib/i18n';

const KEYWORDS = [
  'clause',
  'clauses',
  'library',
  'variant',
  'variants',
  'deviation',
  'deviations',
  'klausel',
  'klauseln',
  'bibliothek',
  'abweichung',
  'abweichungen',
];

export default defineAppCommands({
  id: 'doc-variants.library',
  providers: [
    {
      id: 'doc-variants.go',
      items: (query) => {
        const q = query.trim().toLowerCase();
        if (q && !KEYWORDS.some((k) => k.startsWith(q) || q.startsWith(k))) return [];
        return [
          {
            id: 'doc-variants.library',
            title: t('dvb.library'),
            icon: 'shield',
            group: t('dvb.libraryGroup'),
            keywords: KEYWORDS,
            href: '/documents/clauses',
          },
        ];
      },
    },
  ],
});
